const logItemStatusActions = [
  {
    value: 'edit',
    label: 'Edit',
    icon: 'edit',
    iconLibrary: 'material',
    availableStati: ['draft', 'published'],
  },
  {
    value: 'publish',
    label: 'Publish',
    icon: 'campaign',
    iconLibrary: 'material',
    availableStati: ['draft'],
    isPrimary: true,
    confirmationMessage: "Please confirm that you're ready to publish this update.\n\n"
      + "You can still edit the log item after publishing, but publishing will push it out "
      + "to all relevant communications channels.",
  },
  {
    value: 'archive',
    label: 'Archive',
    icon: 'archive',
    iconLibrary: 'material',
    availableStati: ['published'],
    confirmationMessage: "Please confirm that you'd like to archive this log item.\n\n"
      + "Archiving will preserve the log item but make it visible only to organizers. "
      + "You will still be able to unarchive it later if needed.",
  },
  {
    value: 'unarchive',
    label: 'Unarchive',
    icon: 'unarchive',
    iconLibrary: 'material',
    availableStati: ['archived'],
    confirmationMessage: "Please confirm that you'd like to unarchive this log item.\n\n"
      + "Unarchiving will make the log item visible to non-organizers again.",
  },
];
const logItemStatusActionsMap = Object.fromEntries(logItemStatusActions.map((o) => [o.value, o]));

export {
  logItemStatusActions,
  logItemStatusActionsMap,
};
